"use client";

import axios from "@/utils/axiosInterceptor";

const ctrl = {};

ctrl.get = async (cedularuc, captchaToken = null) => {
  return axios.get("/api/deuda", {
    params: {
      cedularuc,
    },
    headers: {
      "X-Altcha-Token": captchaToken || "",
    },
  });
};

ctrl.getConsultaTitulo = async (desde, hasta, cedula) => {
  return axios.get("/api/deuda/pagos/titulosPagados", {
    params: {
      desde,
      hasta,
      cedula,
    },
  });
};

ctrl.getImprimirTitulo = async (idtitulo, cedularuc) => {
  return axios.get("/api/deuda/pagos/imprimirTitulo", {
    params: {
      idtitulo,
      cedularuc,
    },
  });
};

export default ctrl;